(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Page-menu-new"] && !Shopify.designMode) return;
  try {
    
	jQuery('.play-btn.quit').hide();
	// 
  jQuery('.play-btn.play').on('click', function(e) {
		e.preventDefault();
		// 
		jQuery(this).hide();
		jQuery('.play-btn.quit').show();
		jQuery('.desktop, .mob').addClass('play');
  });
	jQuery('.play-btn.quit').on('click', function(e) {
		e.preventDefault();
		// 
		jQuery(this).hide();
		jQuery('.play-btn.play').show();
		jQuery('.desktop, .mob').removeClass('play');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-multiple-columns"] && !Shopify.designMode) return;
  try {
    
	jQuery('.item-box .content').on('click mouseenter', function(e) {
	e.preventDefault();

	var activeClass = 'active';

	var el = jQuery(this).parent().data('img');

	if (e.handleObj.origType == 'mouseenter' && !jQuery(this).parent().hasClass('clicked')) {
	  
	  activeClass += ' temp';
	  // 
	  jQuery('.collection-multiple').addClass('active');
	} else {

	  activeClass += ' clicked';
	  jQuery('.temp').removeClass('temp');
	  // 
	  jQuery('.collection-multiple').addClass('clicked');
	  // 
	  jQuery('.item-box').removeClass('main');
	  jQuery(this).parent().addClass('main');

	  jQuery('.img-light').removeClass('main');
	  jQuery("."+el).addClass('main');
	}

	jQuery('.item-box').removeClass(activeClass);
	jQuery('.img-light').removeClass(activeClass);
	jQuery(this).parent().addClass(activeClass);
	jQuery("."+el).addClass(activeClass);
  });
  // 
  jQuery('.item-box .content').on('mouseleave', function(e) {
	e.preventDefault();

	if (jQuery(this).parent().hasClass('temp')) {
	  
	  jQuery('.item-box').removeClass('active');
	  jQuery('.item-box.main').addClass('active');
	}
		// 
		jQuery(".img-light").removeClass('active');
		jQuery(".img-light.main").addClass('active');
	// 
	jQuery('.collection-multiple').removeClass('active');
  });
	// 
	jQuery('.close').on('click', function(e) {
		jQuery('.img-light').removeClass('active');
		jQuery('.img-light').removeClass('main');
		jQuery('.img-light').removeClass('clicked');
		jQuery('.item-box').removeClass('active');
		jQuery('.item-box').removeClass('main');
		jQuery('.item-box').removeClass('clicked');
	});
	// 
	// 
	jQuery('.nav-link').on('click', function(e) {
	e.preventDefault();
		// 
		jQuery('.collection-multiple').addClass('clicked');
		// 
		jQuery('.item').removeClass('active');
	jQuery(this).parents('.item').addClass('active');
  });
	// 
	var slider_1 = document.querySelector('#slider_1');
	var slider_1 = new bootstrap.Carousel(slider_1);

	var slider_2 = document.querySelector('#slider_2');
	var slider_2 = new bootstrap.Carousel(slider_2);

	var slider_3 = document.querySelector('#slider_3');
	var slider_3 = new bootstrap.Carousel(slider_3);
	// 
	var slider_1_mob = document.querySelector('#slider_1_mob');
	var slider_1_mob = new bootstrap.Carousel(slider_1_mob);

	var slider_2_mob = document.querySelector('#slider_2_mob');
	var slider_2_mob = new bootstrap.Carousel(slider_2_mob);

	var slider_3_mob = document.querySelector('#slider_3_mob');
	var slider_3_mob = new bootstrap.Carousel(slider_3_mob);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-multiple-link"] && !Shopify.designMode) return;
  try {
    
jQuery('.item-boxX .content').on('click mouseenter', function(e) {
	e.preventDefault();

	var activeClass = 'active';

	var el = jQuery(this).parent().data('img');

	if (e.handleObj.origType == 'mouseenter' && !jQuery(this).parent().hasClass('clicked')) {
	  
	  activeClass += ' temp';
	  // 
	  jQuery('.collection-multiple-link').addClass('active');
	} else {

	  activeClass += ' clicked';
	  jQuery('.temp').removeClass('temp');
	  // 
	  jQuery('.collection-multiple-link').addClass('clicked');
	  // 
	  jQuery('.item-box').removeClass('main');
	  jQuery(this).parent().addClass('main');

	  jQuery('.img-light').removeClass('main');
	  jQuery("."+el).addClass('main');
	}

	jQuery('.item-box').removeClass(activeClass);
	jQuery('.img-light').removeClass(activeClass);
	jQuery(this).parent().addClass(activeClass);
	jQuery("."+el).addClass(activeClass);
});
// 
jQuery('.item-boxX .content').on('mouseleave', function(e) {
	e.preventDefault();

	if (jQuery(this).parent().hasClass('temp')) {
	  
	  jQuery('.item-box').removeClass('active');
	  jQuery('.item-box.main').addClass('active');
	}
		// 
		jQuery(".img-light").removeClass('active');
		jQuery(".img-light.main").addClass('active');
	// 
	jQuery('.collection-multiple-link').removeClass('active');
});
// 
jQuery('.close').on('click', function(e) {
	jQuery('.img-light').removeClass('active');
	jQuery('.img-light').removeClass('main');
	jQuery('.img-light').removeClass('clicked');
	jQuery('.item-box').removeClass('active');
	jQuery('.item-box').removeClass('main');
	jQuery('.item-box').removeClass('clicked');
});
// 
// 
jQuery('.nav-linkX').on('click', function(e) {
e.preventDefault();
	// 
	jQuery('.collection-multiple-link').addClass('clicked');
	// 
	jQuery('.item').removeClass('active');
jQuery(this).parents('.item').addClass('active');
});
// 
var slider_1 = document.querySelector('#slider_1');
var slider_1 = new bootstrap.Carousel(slider_1);

var slider_2 = document.querySelector('#slider_2');
var slider_2 = new bootstrap.Carousel(slider_2);

var slider_3 = document.querySelector('#slider_3');
var slider_3 = new bootstrap.Carousel(slider_3);
// 
var slider_1_mob = document.querySelector('#slider_1_mob');
var slider_1_mob = new bootstrap.Carousel(slider_1_mob);

var slider_2_mob = document.querySelector('#slider_2_mob');
var slider_2_mob = new bootstrap.Carousel(slider_2_mob);

var slider_3_mob = document.querySelector('#slider_3_mob');
	var slider_3_mob = new bootstrap.Carousel(slider_3_mob);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-single-cake"] && !Shopify.designMode) return;
  try {
    
  jQuery('.item-box').on('click mouseenter', function (e) {
    // e.preventDefault();

    var activeClass = 'active';

    var el = jQuery(this).data('img');

    if (e.handleObj.origType == 'mouseenter' && !jQuery(this).hasClass('clicked')) {
      activeClass += ' temp';
      //
      jQuery('.collection-single-cake').addClass('active');
    } else {
      activeClass += ' clicked';
      jQuery('.temp').removeClass('temp');
      //
      jQuery('.collection-single-cake').addClass('clicked');
      //
      jQuery('.item-box').removeClass('main');
      jQuery(this).addClass('main');

      jQuery('.img-light').removeClass('main');
      jQuery('.' + el).addClass('main');
    }

    jQuery('.item-box').removeClass(activeClass);
    jQuery('.img-light').removeClass(activeClass);
    jQuery(this).addClass(activeClass);
    jQuery('.' + el).addClass(activeClass);
  });
  //
  jQuery('.item-box').on('mouseleave', function (e) {
    e.preventDefault();

    if (jQuery(this).hasClass('temp')) {
      jQuery('.item-box').removeClass('active');
      jQuery('.item-box.main').addClass('active');
    }
    //
    jQuery('.img-light').removeClass('active');
    jQuery('.img-light.main').addClass('active');
    //
    jQuery('.collection-single-cake').removeClass('active');
  });
  //
  jQuery('.close').on('click', function (e) {
    jQuery('.img-light').removeClass('active');
    jQuery('.img-light').removeClass('main');
    jQuery('.img-light').removeClass('clicked');
    jQuery('.item-box').removeClass('active');
    jQuery('.item-box').removeClass('main');
    jQuery('.item-box').removeClass('clicked');
  });
  //
  //
  jQuery('.nav-link').on('click', function (e) {
    e.preventDefault();
    //
    jQuery('.collection-single-cake').addClass('clicked');
    //
    jQuery('.item').removeClass('active');
    jQuery(this).parents('.item').addClass('active');
  });

  //
  var slider_1 = document.querySelector('#slider_1');
  var slider_1 = new bootstrap.Carousel(slider_1);

  var slider_2 = document.querySelector('#slider_2');
  var slider_2 = new bootstrap.Carousel(slider_2);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-single"] && !Shopify.designMode) return;
  try {
    
	jQuery('.item-box .content').on('click mouseenter', function(e) {
	e.preventDefault();

	var activeClass = 'active';

	var el = jQuery(this).parent().data('img');

	if (e.handleObj.origType == 'mouseenter' && !jQuery(this).parent().hasClass('clicked')) {
	  
	  activeClass += ' temp';
	  // 
	  jQuery('.collection-single').addClass('active');
	} else {

	  activeClass += ' clicked';
	  jQuery('.temp').removeClass('temp');
	  // 
	  jQuery('.collection-single').addClass('clicked');
	  // 
	  jQuery('.item-box').removeClass('main');
	  jQuery(this).parent().addClass('main');

	  jQuery('.img-light').removeClass('main');
	  jQuery("."+el).addClass('main');
	}

	jQuery('.item-box').removeClass(activeClass);
	jQuery('.img-light').removeClass(activeClass);
	jQuery(this).parent().addClass(activeClass);
	jQuery("."+el).addClass(activeClass);
  });
  // 
  jQuery('.item-box .content').on('mouseleave', function(e) {
	e.preventDefault();

	if (jQuery(this).parent().hasClass('temp')) {
	  
	  jQuery('.item-box').removeClass('active');
	  jQuery('.item-box.main').addClass('active');
	}
		// 
		jQuery(".img-light").removeClass('active');
		jQuery(".img-light.main").addClass('active');
	// 
	jQuery('.collection-single').removeClass('active');
  });
	// 
	jQuery('.close').on('click', function(e) {
		jQuery('.img-light').removeClass('active');
		jQuery('.img-light').removeClass('main');
		jQuery('.img-light').removeClass('clicked');
		jQuery('.item-box').removeClass('active');
		jQuery('.item-box').removeClass('main');
		jQuery('.item-box').removeClass('clicked');
	});
	// 
	var slider = document.querySelector('#slider');
	var slider = new bootstrap.Carousel(slider);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-old"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  jQuery('.desk-footer a[data-bs-toggle]').click(function () {
    jQuery('html, body').animate(
      {
        scrollTop: jQuery(document).height(),
      },
      300
    );
  });
  //
  jQuery('.field__input').focus(function () {
    jQuery(this).parents('.newsletter-form__field-wrapper').find('label').hide();
  });
  jQuery('.field__input').focusout(function () {
    if (jQuery(this).val() == 0) {
      jQuery(this).parents('.newsletter-form__field-wrapper').find('label').show();
    } else {
      jQuery(this).parents('.newsletter-form__field-wrapper').find('label').hide();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-old"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-about-us"] && !Shopify.designMode) return;
  try {
    

	var myCarousel = document.querySelector('#img-slider');
	var carousel = new bootstrap.Carousel(myCarousel);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-archive"] && !Shopify.designMode) return;
  try {
    
  var activeBox = '';
  //
  jQuery('.years a').on('click', function (e) {
    e.preventDefault();

    //
    window.activeBox = '';
    jQuery('.menu-archive').addClass('active');
    //
    var year = jQuery(this).data('year');
    var number = jQuery(this).data('number');

    //
    jQuery('.access-denied.text').addClass('d-none');
    jQuery('.season-data').addClass('d-none');
    jQuery('.season-data').removeClass('active');
    jQuery('.replaceImage').attr('src', '');
    jQuery('.img-light').addClass('d-none');

    jQuery('li.season').removeClass('active');
    jQuery('.years a').removeClass('active');

    jQuery(this).addClass('active');
    //
    if (jQuery(this).hasClass('access-denied')) {
      jQuery('.access-denied.text').removeClass('d-none');
    }
    //
    if (jQuery(this).hasClass('show-seasons')) {
      jQuery('li.season.year-' + year).addClass('active');
    }
    //
    if (jQuery(this).hasClass('no-seasons')) {
      jQuery('.season-data.year-' + year + '.number-1').removeClass('d-none');
      jQuery('.season-data.year-' + year + '.number-1').addClass('active');
    }
        
    //
    $('.menu-archive .icons').hide();
    $('.menu-archive .icons').removeClass('d-flex');
    if (jQuery(this).hasClass('is-season')) {
      jQuery('li.season.year-' + year).addClass('active');
      jQuery('.years a.year-' + year).addClass('active');
      jQuery('.season-data.year-' + year + '.number-' + number).removeClass('d-none');
      jQuery('.season-data.year-' + year + '.number-' + number).addClass('active');

      if (jQuery('.season-data.year-' + year + '.number-' + number).data('gif')) {
        jQuery('.replaceImage').attr('src', jQuery('.season-data.year-' + year + '.number-' + number).data('gif'));
        jQuery('.img-light').removeClass('d-none');

        jQuery(this).parents('.shopify-section').addClass('gif-season');
      } else {
        jQuery(this).parents('.shopify-section').removeClass('gif-season');
      }
    }
    if (jQuery(this).hasClass('no-seasons')) {
      jQuery('.season-data.year-' + year).removeClass('d-none');
      jQuery('.season-data.year-' + year).addClass('active');

      if (jQuery('.season-data.year-' + year).data('gif')) {
        jQuery('.replaceImage').attr('src', jQuery('.season-data.year-' + year).data('gif'));
        jQuery('.img-light').removeClass('d-none');

        jQuery(this).parents('.shopify-section').addClass('gif-season');
      } else {
        jQuery(this).parents('.shopify-section').removeClass('gif-season');
      }
    }
  });

  //
  jQuery('.season-data .img').on('click', function (e) {
    var box = jQuery(this).data('box');
    window.activeBox = box;
    jQuery('.img').removeClass('active');
    jQuery(this).addClass('active');
    jQuery('.img-nxt-btn-wrapper').show();
    jQuery('.img-light').removeClass('d-none');

    $('.menu-archive .icons').show();
    $('.menu-archive .icons').addClass('d-flex');

    //
    if (jQuery(window).width() <= 767) {
      jQuery('body').addClass('light-box-showed');
    }

    //
    jQuery('.img img').removeClass('active');
    jQuery(this).find('.img-f').addClass('active');
    var src_1 = jQuery(this).find('.img-f').attr('src');
    jQuery('.replaceImage').attr('src', src_1);

    if (jQuery(this).parents('.season-data').data('gif')) {
      jQuery(this).parents('.shopify-section').addClass('gif-season');
    }
  });

  jQuery('.close').on('click', function (e) {
    e.preventDefault();

    jQuery('.img-light').addClass('d-none');
    jQuery('body').removeClass('light-box-showed');

    
    if(jQuery(this).parents('.season-data').data('gif')) {
      $('.menu-archive .icons').hide();
      $('.menu-archive .icons').removeClass('d-flex');

      jQuery('.replaceImage').attr('src', jQuery(this).parents('.season-data').data('gif'));
    }
  });

  //
  jQuery('.nxt-btn .next').on('click', function (e) {
    e.preventDefault();

    if (window.activeBox == '') {
      jQuery('.season-data.active .box-1').click();
    } else {
      jQuery('.season-data.active .box-' + (window.activeBox + 1)).click();
    }
  });

  //
  jQuery('.img-nxt-btn .next').on('click', function (e) {
    e.preventDefault();

    if (jQuery('.season-data.active .box-' + window.activeBox).hasClass('imgs')) {
      var img_f = jQuery('.season-data.active .box-' + window.activeBox + ' .img-f');
      var img_s = jQuery('.season-data.active .box-' + window.activeBox + ' .img-s');

      if (img_s.hasClass('active')) {
        jQuery('.season-data.active .box-' + (window.activeBox + 1)).click();
      } else if (img_f.hasClass('active')) {
        jQuery('.img img').removeClass('active');
        img_s.addClass('active');

        var src_2 = img_s.attr('src');
        jQuery('.replaceImage').attr('src', src_2);
      }
    } else {
      if (window.activeBox == '') {
        jQuery('.season-data.active .box-1').click();
      } else {
        jQuery('.season-data.active .box-' + (window.activeBox + 1)).click();
      }
    }
  });

  //
  // var slider = document.querySelector('#slider');
  // var slider = new bootstrap.Carousel(slider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-art"] && !Shopify.designMode) return;
  try {
    
	jQuery(".mbox").on('click', function(e) {
		if(jQuery(this).hasClass('active')) {
			jQuery(this).removeClass('active');
		} else {
			jQuery(this).addClass('active');
		}
	});

	jQuery('.img-slider').slick({
		dots: false,
		arrows: false,
		centerPadding: '60px',
		infinite: true,
		variableWidth: true,
		slidesToShow: 3,
		slidesToScroll: 1
	});

	$(document).on('click', '.linksDropdownLink', function(e) {
		e.preventDefault()
		$(this).parents('details').removeAttr('open')
		$(this).parents('.shopify-section').find('.mbox.active').click()

		setTimeout(() => {
			const thisScrollPos = $($(this).attr('href')).offset().top - ($('.section-header .header').outerHeight() + parseInt($(this).parents('.page-art').css('padding-top')))
	
			console.log($($(this).attr('href')).offset().top, ($('.section-header .header').outerHeight() + parseInt($(this).parents('.page-art').css('padding-top'))));
	
			$("html, body").animate({
				// scrollTop: $($(this).attr('href')).offset().top - ($('.section-header .header').outerHeight() + 30)
				// scrollTop: $($(this).attr('href')).offset().top - ($('.section-header .header').outerHeight() - jQuery(window).width() > 767 ? 30 : 15)
				scrollTop: thisScrollPos
			}, 1000);
	
			$($(this).attr('href')).find('.mbox').click();
		}, 100);
	})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-events"] && !Shopify.designMode) return;
  try {
    
  jQuery('.box').on('click mouseenter', function(e) {
    e.preventDefault();

    var activeClass = 'active';
    var displayClass = 'd-none';

    var el = jQuery(this).data('id');

    if (e.handleObj.origType == 'mouseenter' && !jQuery(this).hasClass('clicked')) {

      activeClass += ' temp';
      displayClass += ' temp';
      //
      jQuery('.events-page').addClass('active');
    } else {

      activeClass += ' clicked';
      displayClass += ' clicked';
      jQuery('.temp').removeClass('temp');
      //
      jQuery('.events-page').addClass('clicked');
      //
      jQuery('.box').removeClass('main');
      jQuery(this).addClass('main');
      jQuery('.row.item').removeClass('main');
      jQuery('.row.item.'+el).addClass('main');
    }


    jQuery('.box').removeClass(activeClass);
    jQuery(this).addClass(activeClass);

    jQuery('.row.item').addClass(displayClass);
    jQuery('.row.item.'+el).removeClass(displayClass);
  });
  //
  jQuery('.box').on('mouseleave', function(e) {
    e.preventDefault();

    if (jQuery(this).hasClass('temp')) {

      var el = jQuery(this).data('id');

      jQuery('.box').removeClass('active');
      jQuery('.row.item').addClass('d-none');
      //
      jQuery('.box.main').addClass('active');
      jQuery('.row.item.main').removeClass('d-none');

      //
      if(!jQuery('.events-page').hasClass('clicked')) {
        jQuery(this).addClass('active');
        jQuery('.row.item.'+el).removeClass('d-none');
      }
    }
    //
    // jQuery('.events-page').removeClass('active');
  });
  //
  jQuery('.colapsible').on('click', function(e) {
    jQuery('.events-page').addClass('clicked');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-gallery"] && !Shopify.designMode) return;
  try {
    
		// 
		jQuery(".draggable").draggable();
		
		// 
		var zIndexes = ["2","3","5","7","9"];
		var rotates = ["30","-16","19","-14","13","33","-28","-7","10","21","-10","-17"];
		var translates = ["-50","-10","50","60","15","-40"];
		// 
		jQuery(".draggable").each(function(){
			// 
			var zIndex = Math.floor(Math.random() * zIndexes.length);
			var rotate = Math.floor(Math.random() * rotates.length);
			var translate = Math.floor(Math.random() * translates.length);
			// 
			jQuery(this).css({
				"transform": "rotate("+rotates[rotate]+"deg) ",
				"z-index": zIndexes[zIndex]
			});
		});
		// 
		var lastClickedItem = '';
		var lastClickedItemZindex = '';
		jQuery(".draggable").on('click', function(e) {

			jQuery(lastClickedItem).css("z-index", lastClickedItemZindex);
			// 
			if(lastClickedItem != '.img-' + jQuery(this).data('num')) {
				lastClickedItem = '.img-' + jQuery(this).data('num');
				lastClickedItemZindex = jQuery(this).css('z-index');
			}		
			// 
			jQuery(this).css("z-index", '11');
		});

		// 
		// var total = jQuery(".draggable").length;

		// if( total >= 47 ) {

		// 	for (let i = 0; i < (total - 47); i++) {

		// 		var el = Math.floor(Math.random() * total);
		// 		// 
		// 		jQuery('.img-'+el).addClass('d-none');
		// 	}
		// }

	
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-menu"] && !Shopify.designMode) return;
  try {
    
	jQuery('.play-btn.quit').hide();
	// 
  jQuery('.play-btn.play').on('click', function(e) {
		e.preventDefault();
		// 
		jQuery(this).hide();
		jQuery('.play-btn.quit').show();
		jQuery('.desktop, .mob').addClass('play');
  });
	jQuery('.play-btn.quit').on('click', function(e) {
		e.preventDefault();
		// 
		jQuery(this).hide();
		jQuery('.play-btn.play').show();
		jQuery('.desktop, .mob').removeClass('play');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-store"] && !Shopify.designMode) return;
  try {
    
  jQuery('.item.default .img').on('click', function(e) {
    e.preventDefault();

    var num = jQuery(this).data('id');
    jQuery('.nav-link.nav-'+num).click();
  });
  // 
  jQuery('.nav-link, .sectionHeading').on('click mouseenter', function(e) {
    var el = jQuery(this).data('id');
    if (e.handleObj.origType == 'mouseenter') {
      $('#' + el).addClass('showTemp')
    }

    if (e.handleObj.origType == 'click') {
      $('#' + el).removeClass('d-none')
      $('#' + el).siblings().addClass('d-none')
    }
  })
  jQuery('.nav-link, .sectionHeading').on('mouseleave', function(e) {
    jQuery('.row.item.showTemp').removeClass('showTemp');
  })
  /* jQuery('.nav-link, .sectionHeading').on('click mouseenter', function(e) {
    e.preventDefault();

    jQuery('.default').addClass('d-none');

    var activeClass = 'active';
    var displayClass = 'd-none';

    var el = jQuery(this).data('id');

    if (e.handleObj.origType == 'mouseenter' && !jQuery(this).hasClass('clicked')) {

      activeClass += ' temp';
      displayClass += ' temp';
    } else {

      activeClass += ' clicked';
      displayClass += ' clicked';
      jQuery('.temp').removeClass('temp');
      // 
      jQuery('.nav-link').removeClass('main');
      jQuery(this).addClass('main');
      jQuery('.row.item').removeClass('main');
      jQuery('.row.item.'+el).addClass('main');
    }


    jQuery('.nav-link').removeClass(activeClass);
    jQuery(this).addClass(activeClass);

    jQuery('.row.item').addClass(displayClass);
    jQuery('.row.item.'+el).removeClass(displayClass);
  });
  // 
  jQuery('.nav-link, .sectionHeading').on('mouseleave', function(e) {
    e.preventDefault();

    if (jQuery(this).hasClass('temp')) {
      
      jQuery('.nav-link').removeClass('active');
      jQuery('.row.item').addClass('d-none');
      // 
      jQuery('.nav-link.main').addClass('active');
      jQuery('.row.item.main').removeClass('d-none');
    }
  }); */

  
  jQuery(document).ready(function($) {
    var myCarousel_mob = document.querySelector('#img-slider-mob');
    var carousel_mob = new bootstrap.Carousel(myCarousel_mob);
    console.log(carousel_mob);
    
    var myCarousel_mob__2nd = document.querySelector('#img-slider-mob__2nd');
    var carousel_mob__2nd = new bootstrap.Carousel(myCarousel_mob__2nd);
  });
  // 
  jQuery(".nav.store a[data-bs-toggle]").click(function(){
      // jQuery('#img-slider-mob').hide();
      $($(this).data('hideTarget')).hide();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["small-footer"] && !Shopify.designMode) return;
  try {
    
  // jQuery('.footer ').addClass('small');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spred-text"] && !Shopify.designMode) return;
  try {
    
  if (typeof CustomCounter !== 'function') {
    class CustomCounter extends HTMLElement {
      constructor() {
        super();
        this.timer = null;

        // Parse the data attributes
        this.day = parseInt(this.dataset.day, 10);
        this.month = parseInt(this.dataset.month, 10);
        this.year = parseInt(this.dataset.year, 10);
        this.hour = parseInt(this.dataset.hour || 0, 10);
        this.minute = parseInt(this.dataset.minute || 0, 10);
        this.second = parseInt(this.dataset.second || 0, 10);

        // Bind methods
        this.updateCountdown = this.updateCountdown.bind(this);

        this.init();
        document.addEventListener('shopify:section:load', () => {
          this.init();
        });
      }

      init() {
        if (this.timer) clearInterval(this.timer);

        if (!this.day || !this.month || !this.year) {
          this.textContent = 'Invalid date provided!';
          return;
        }

        // Set the target date in EST timezone
        this.targetDate = this.getESTDate(this.year, this.month - 1, this.day, this.hour, this.minute, this.second);

        console.log('Target Date (EST):', this.targetDate);

        this.timer = setInterval(this.updateCountdown, 1000);
        this.updateCountdown(); // Call immediately to initialize the content
      }

      getESTDate(year, month, day, hour, minute, second) {
        // Create a UTC date first
        const utcDate = new Date(Date.UTC(year, month, day, hour, minute, second));

        // Offset for EST (UTC-5)
        const offset = 5 * 60 * 60 * 1000;
        return new Date(utcDate.getTime() - offset); // Adjust for EST
      }

      getESTNow() {
        // Get the current UTC time and convert it to EST (UTC-5)
        const now = new Date();
        const utcNow = new Date(
          Date.UTC(
            now.getUTCFullYear(),
            now.getUTCMonth(),
            now.getUTCDate(),
            now.getUTCHours(),
            now.getUTCMinutes(),
            now.getUTCSeconds()
          )
        );

        const offset = 10 * 60 * 60 * 1000; // EST is UTC-5
        return new Date(utcNow.getTime() - offset); // Adjust for EST
      }

      updateCountdown() {
        const estNow = this.getESTNow(); // Get current EST time
        const timeRemaining = this.targetDate - estNow;

        if (timeRemaining <= 0) {
          clearInterval(this.timer);
          this.textContent = "Time's up!";
          return;
        }

        const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        this.textContent = `${days}D ${hours}H ${minutes}M ${seconds}S`;
      }

      disconnectedCallback() {
        if (this.timer) {
          clearInterval(this.timer);
        }
      }
    }

    customElements.define('custom-counter', CustomCounter);
  }

  } catch(e) { console.error(e); }
})();
})();
